import { resolveInject } from "app/di";
import axios from "axios";
import { IAppConfigProvider } from "./config/app-config-loader.service";

export const login = async (email: string, password: string) => {
    const appConfig = resolveInject(IAppConfigProvider);
    const backendUrl = appConfig.config.dataServiceOptions.backendUrl;

    if (!email || !password) {
        return;
    }

    return await axios.post(
        backendUrl + "/login",
        {
            email,
            password
        },
        { withCredentials: true }
    );
};

export const loginIdproviderCallback = async (params: URLSearchParams) => {
    // Assuming an OAuth2 auth code is already available server side
    const appConfig = resolveInject(IAppConfigProvider);
    const backendUrl = appConfig.config.dataServiceOptions.backendUrl;
    return await axios.get(backendUrl + "/auth/idprovider-token", {
        params,
        withCredentials: true
    });
};

export const sparqlExecute = async (
    versionUrl: string,
    headersObj: { [name: string]: string },
    body?: string
) => {
    const appConfig = resolveInject(IAppConfigProvider);
    const backendUrl = appConfig.config.dataServiceOptions.backendUrl;

    try {
        const response = await axios.post(
            backendUrl + "/execute-sparql",
            {
                versionUrl,
                body,
                headersObj
            },
            { withCredentials: true }
        );
        return response;
    } catch (err) {
        // If the session is not valid anymore, remove user from local storage.
        if (
            typeof err === "object" &&
            err !== null &&
            "response" in err &&
            typeof (err as any).response === "object" &&
            (err as any).response !== null &&
            "status" in (err as any).response &&
            (err as any).response.status === 401
        ) {
            localStorage.removeItem("user");
        }
        return;
    }
};
